import {get} from 'lodash';

export default (state = {}, {coachId, res}: any) => {
  return {
    ...state,
    edge365: {
      ...get(state, 'edge365', {}),
      [coachId]: res,
    },
  };
};
